import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type { markStoriesAsReadInput } from '@sorare/core/src/__generated__/globalTypes';
import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  MarkStoriesAsReadMutation,
  MarkStoriesAsReadMutationVariables,
} from './__generated__/useMarkStoriesAsRead.graphql';

const MARK_STORIES_AS_READ = gql`
  mutation MarkStoriesAsReadMutation($input: markStoriesAsReadInput!) {
    markStoriesAsRead(input: $input) {
      stories {
        id
        aasmState
      }
      errors {
        code
        message
        path
      }
    }
  }
` as TypedDocumentNode<
  MarkStoriesAsReadMutation,
  MarkStoriesAsReadMutationVariables
>;

export const useMarkStoriesAsRead = () => {
  const [mutate, { loading }] = useMutation(MARK_STORIES_AS_READ);

  return {
    readStories: async (input: markStoriesAsReadInput) => {
      return mutate({
        variables: { input },
      });
    },
    loading,
  };
};
